import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"

class Pie extends Component {


    constructor(props) {
        super(props)
        this.items = props.Item
    }


    getOption = () => {
        const data = this.items;
        const item = data.map(item => (item.ItemName))


        const Data = data.map((Data) => ({
            value: Data.TotalAmount,
            name: Data.ItemName
        }));


        return {
            toolbox: {
                show: true,
            },
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c}",
            },

            color: ["#02a499", "#f8b425", "#ec4561", "#38a4f8", "#3c4ccf"],
            series: [
                {
                    name: "Total sales",
                    type: "pie",

                    radius: ["55%", "75%"],
                    center: ["50%", "50%"],

                    minAngle: 5,
                    data: Data,

                    itemStyle: {
                        borderRadius: 6,
                        borderColor: "#fff",
                        borderWidth: 2,

                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.15)",
                        },
                    },

                    label: {
                        show: false,
                    },

                    labelLine: {
                        show: false,
                    },
                },
            ],
        }
    }

    render() {

        const overallSalesAmount = parseFloat(this.props.overallSalesAmount || 0);
        const colors = ["#02a499", "#f8b425", "#ec4561", "#38a4f8", "#3c4ccf"];

        return (
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>

                <div style={{ flex: "1 1 240px", minWidth: "220px" }}>
                    <ReactEcharts
                        style={{ height: "220px", width: "100%" }}
                        option={this.getOption()}
                    />
                </div>

                <div style={{ flex: "1 1 240px", minWidth: "220px", paddingLeft: "14px", boxSizing: "border-box" }}>

                    <div style={{
                        display: "flex", alignItems: "center", marginBottom: "6px",
                        paddingBottom: "6px", borderBottom: "1px solid #eef0f4",
                    }}>
                        <span style={{ flex: 1 }} />
                        <span style={{ width: "62px", textAlign: "right", fontSize: "10px", fontWeight: 700, color: "#000000", textTransform: "uppercase" }}>Overall</span>
                    </div>

                    {this.items.map((item, index) => {
                        const value = parseFloat(item.TotalAmount || 0);
                        const overallPercent = overallSalesAmount > 0
                            ? ((value / overallSalesAmount) * 100).toFixed(1) : 0;

                        return (
                            <div key={index} style={{
                                display: "flex", alignItems: "center", padding: "6px 0",
                                fontSize: "13px",
                                borderBottom: index !== this.items.length - 1 ? "1px solid #f4f5f7" : "none",
                            }}>
                                <div style={{ width: "9px", height: "9px", minWidth: "9px", backgroundColor: colors[index % colors.length], marginRight: "8px", borderRadius: "2px" }} />
                                <span style={{ flex: 1, color: "#495057", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingRight: "6px" }}>
                                    {item.ItemName}
                                </span>
                                <span style={{ width: "62px", textAlign: "right", fontWeight: 700, color: "#000000", fontVariantNumeric: "tabular-nums" }}>
                                    {overallPercent}%
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
export default Pie